import { render, staticRenderFns } from "./LastTicketsBetItem.vue?vue&type=template&id=1f32d3ef&scoped=true"
import script from "./LastTicketsBetItem.vue?vue&type=script&lang=js"
export * from "./LastTicketsBetItem.vue?vue&type=script&lang=js"
import style0 from "./LastTicketsBetItem.vue?vue&type=style&index=0&id=1f32d3ef&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f32d3ef",
  null
  
)

export default component.exports